import listReportEmails from 'modules/reports/api/reportEmails/listReportEmails'
import ReportsModalBody from 'modules/reports/components/Modal/Body'
import ReportsModalExtension from 'modules/reports/components/Modal/Extension'
import ReportsModalTitle from 'modules/reports/components/Modal/Title'
// import useStyles from './ReportsEmailModalAdvanced.styles'
import useCore from 'modules/reports/hooks/core'
import useMount from 'modules/reports/hooks/mount'
import ReportEmail from 'modules/reports/models/ReportEmail'
import React, {useState} from 'react'
import User from 'modules/reports/models/User'
import {Grid} from '@material-ui/core'
import SendIcon from '@material-ui/icons/Send'

type Props = {
  reportId: number
}

function ReportsEmailModalAdvanced(props: Props) {
  // const classes = useStyles()

  const {pt} = useCore('reports', 'modals', 'EmailAdvanced')
  const [reportEmails, setReportEmails] = useState<ReportEmail[]>()

  async function loadReportEmails() {
    const response = await listReportEmails({reportId: props.reportId})
    setReportEmails(response.data)
  }

  function renderReportEmailTo(to: (number | string)[]) {
    return to.map(to => (typeof to === 'string' ? to : User.cache[to]))
  }

  function renderReportEmail(reportEmail: ReportEmail) {
    return (
      <Grid container key={reportEmail.id}>
        <Grid item xs={6}>
          {renderReportEmailTo(reportEmail.to)}
        </Grid>

        <Grid item xs={2}>
          <header>
            <b>Format</b>
          </header>

          {reportEmail.format}
        </Grid>

        <Grid item xs={2}>
          {reportEmail.formattedLastEmail}
        </Grid>

        <Grid item xs={2}>
          <SendIcon />
          Resend
        </Grid>
      </Grid>
    )
  }

  useMount(() => {
    loadReportEmails()
  })

  return (
    <ReportsModalExtension>
      <ReportsModalBody width={600}>
        <ReportsModalTitle>{pt('title')}</ReportsModalTitle>

        {reportEmails
          ? reportEmails.map(reportEmail => renderReportEmail(reportEmail))
          : 'Loading...'}
      </ReportsModalBody>
    </ReportsModalExtension>
  )
}

export default ReportsEmailModalAdvanced
